// extracted by mini-css-extract-plugin
module.exports = {"dropUp":"JopiDropdownItems_dropUp__GNLGr"};